export default {
  props: {
    show: Boolean, // 是否显示抽屉
    goodsNum: Number, // 选择商品数量限制
    selections: Array, // 交互的商品列表
    categoryList: Array, // 商品分类列表
    disChooseList: Array, // 禁止选择的商品
    disableSKUSelection: Boolean, // 是否允许选择sku
  },

  data() {
    return {
      env: process.env,
      visible: true,

      form: {
        name: "",
        categoryId: "",
      },
      categoryIdList: [],
      categoryProps: {
        value: "id",
        label: "text",
        // checkStrictly: true,
      },

      list: [],
      loading: false,
      imgPreviewList: [],
      imgPreviewVisible: false,
      multipleSelection: [],

      total: 0,
      pageNum: 1,
      pageSize: 30,
      pageCount: 1,
    };
  },
  created() {
    console.log("商品选择created", this.categoryList);
  },
  mounted() {
    this.loadData((data) => {
      if (data.length) {
        this.multipleSelection = this.selections;
        this.tableSelected();
      }
    });
  },
  computed: {
    multipleSelectionLength() {
      const { multipleSelection, disableSKUSelection } = this;

      if (disableSKUSelection) {
        return multipleSelection.length;
      }

      const filter = multipleSelection.filter((item) => item.spuId);
      return filter.length;
    },
  },

  methods: {
    loadData(cb) {
      const { form, pageSize, pageNum } = this;
      this.loading = true;
      this.$store
        .dispatch("goodShift/getGoodSpuList", {
          ...form,
          size: pageSize,
          current: pageNum,
        })
        .then((data) => {
          this.loading = false;
          const { records, total, pages } = data;
          console.log("商品列表", records);
          if (records.length) {
            records.forEach((item, index) => {
              if (item.skuList) {
                item.skuList.forEach((item2, index2) => {
                  records[index].skuList[index2].skuId = item2.goodsId;
                  records[index].skuList[index2].id = item2.goodsId;
                  records[index].skuList[index2].spuName = item.name;
                  records[index].skuList[index2].specType = item.specType;
                  if (item.specType !== 0) {
                    records[index].skuList2 = records[index].skuList;
                  }
                });
              }
            });
          }
          this.list = records || [];
          this.total = total;
          this.pageCount = pages;

          cb && cb(records);
        });
    },
    // 表格默认选中
    tableSelected() {
      const { list = [], multipleSelection, disableSKUSelection } = this;
      if (!list.length) {
        return;
      }
      if (disableSKUSelection) {
        multipleSelection.forEach((item) => {
          const findIndex = list.findIndex((findItem) => findItem.id === item.id);
          if (findIndex !== -1) {
            if (item.specType) {
              list[findIndex].skuList = item.skuList;
            } else {
              list[findIndex].stockWarningNum = item.stockWarningNum;
            }
            this.toggleSelection(list[findIndex], true);
          }
        });
        return;
      }
      list.forEach((item) => {
        const len = item.skuList && item.skuList.length;
        const len2 = multipleSelection.filter((sItem) => item.id === sItem.spuId).length;
        if (len === len2) {
          this.toggleSelection(item, true);
        }
        if (item.skuList) {
          item.skuList.forEach((item2) => {
            if (multipleSelection.some((item3) => item2.id === item3.id || item2.id === item3.skuId)) {
              this.toggleSelection(item2, true);
              this.$nextTick(() => {
                this.$refs.multipleTable.toggleRowExpansion(item, true);
              });
            }
          });
        }
      });
    },

    // 重置搜索
    resetSearchForm() {
      this.categoryId = "";
      this.$refs.searchForm.resetFields();
    },

    // 搜索查询
    submitSearchForm() {
      this.pageNum = 1;
      this.loadData(() => {
        this.tableSelected();
      });
    },

    // 分类选择
    categoryChange(value) {
      console.log("value", value);
      this.form.categoryId = value[value.length - 1];
    },

    // 选择商品(当用户手动勾选数据行的 Checkbox 时触发的事件)
    select(selection, row) {
      if (this.disableSKUSelection) {
        this.multipleSelection = selection;
        return;
      }
      const selected = selection.some((item) => item === row);
      if (row.spuId) {
        const [spuFilter] = this.list.filter((item) => item.id === row.spuId);
        // 选中
        if (selected) {
          const len = spuFilter.skuList.length;
          const skuFilter = selection.filter((item) => item.spuId === row.spuId);
          if (len === skuFilter.length) {
            this.toggleSelection(spuFilter, true);
          }
        } else {
          if (!row.skuId) {
            // 点击的多规格的spu商品，要把spu下的sku商品全部清除掉
            this.multipleSelection = this.multipleSelection.filter((item) => {
              return item.spuId !== row.spuId;
            });
          } else {
            // 点击sku商品，清除指定的sku商品
            const index = this.multipleSelection.findIndex((item) => item.skuId === row.skuId);
            if (index !== -1) {
              this.multipleSelection.splice(index, 1);
            }
          }
          this.toggleSelection(spuFilter, false);
          console.log("this.multipleSelection", this.multipleSelection);
        }
      } else if (row.skuList) {
        const { multipleSelection } = this;
        if (!selected) {
          row.skuList.forEach((item) => {
            const findIndex = multipleSelection.findIndex((item2) => item2.skuId === item.skuId);
            if (findIndex !== -1) {
              multipleSelection.splice(findIndex, 1);
            }
          });
          this.multipleSelection = multipleSelection;
        }
      }

      this.selectSkuList(row, selected);
    },

    // 选择商品(当用户手动勾选全选 Checkbox 时触发的事件)
    selectAll(selection) {
      if (this.disableSKUSelection) {
        this.multipleSelection = selection;
        return;
      }
      const isSelect = this.list.some((item) => selection.includes(item));
      if (isSelect) {
        selection.forEach((item) => {
          this.selectSkuList(item, isSelect);
        });
      } else {
        this.list.forEach((item) => {
          this.selectSkuList(item, isSelect);
        });
        this.multipleSelection = [];
      }
    },

    // 商品子级选择
    selectSkuList(row, selected) {
      if (row.skuList && Array.isArray(row.skuList)) {
        row.skuList.forEach((item) => {
          this.toggleSelection(item, selected);
          this.selectSkuList(item, selected);
        });
      }
    },

    // 切换选择
    toggleSelection(row, select) {
      if (row) {
        this.$nextTick(() => {
          this.$refs.multipleTable.toggleRowSelection(row, select);
        });
      }
    },

    // 选择商品(当选择项发生变化时会触发该事件)
    selectionChange(selection) {
      if (this.disableSKUSelection) {
        return;
      }
      this.debounce(() => {
        const { multipleSelection } = this;
        let concat = [...multipleSelection, ...selection];
        concat = concat.filter((item) => !item.skuList);

        const obj = {};

        // 数组去重
        concat = concat.reduce((cur, next) => {
          obj[next.skuId] ? "" : (obj[next.skuId] = true && cur.push(next));
          return cur;
        }, []);

        this.multipleSelection = concat;
      }, 100);
    },

    // 修改每页显示个数
    sizeChange(pageSize) {
      this.pageNum = 1;
      this.pageSize = pageSize;
      this.loadData(() => {
        this.tableSelected();
      });
    },

    // 修改页码
    currentChange(pageNum) {
      this.pageNum = pageNum;
      this.loadData(() => {
        this.tableSelected();
      });
    },

    // 显示图片预览
    imgPreview(imgs) {
      this.imgPreviewList = JSON.parse(imgs);
      this.imgPreviewVisible = true;
    },

    // 隐藏图片预览
    imgPreviewClose() {
      this.imgPreviewVisible = false;
    },

    // 防抖
    debounce(fun, wait) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(fun, wait);
    },

    // 取消
    cancel() {
      this.visible = false;
      this.debounce(() => {
        this.$emit("update:show", false);
      }, 300);
    },

    // 确定
    confirm() {
      const { cancel, multipleSelection, goodsNum } = this;
      if (!multipleSelection.length) {
        this.$message.warning("请先选择商品");
        return;
      }
      if (multipleSelection.length > 1 && goodsNum === 1) {
        this.$message.warning("只能选择一个商品");
        return;
      }
      if (this.disableSKUSelection) {
        const selection = JSON.parse(JSON.stringify(multipleSelection));
        console.log("selection", selection);
        this.$emit("update:selections", selection);
        cancel();
        return;
      }
      if (multipleSelection.length) {
        const selections = multipleSelection.filter((item) => item.spuId);
        console.log("selections", selections);
        this.$emit("update:selections", selections);
      }
      cancel();
    },

    // 禁止选择已有方案
    selectionDisable(row) {
      const { disChooseList } = this;
      if (
        disChooseList.find((item) => {
          return item === row.id;
        })
      ) {
        return false;
      }
      return true;
    },
  },
};
